/* eslint-disable import/prefer-default-export */
import { formatDate } from '@/helpers';

export const getJsonData = data => JSON.parse(data.replaceAll(' " ', '"'));

export const getAddress = data => {
    if(data && data === 'true' ) {
        return null;
    }
    return data;
};

export const getCountry = data => {
    const tempStore = {};
    if(Array.isArray(data)) {
        data.forEach((entityAddress, i) => {
            Object.keys(entityAddress).forEach(key => {
                tempStore[key + i] = entityAddress[key];
            });
        });
        return tempStore;
    }
    return data.COUNTRY;
};

export const getAlias = (data, type) => {
    if(data?.alias)
        return data.alias;
    if(type === 'individual')
        return getJsonData(data.data)?.INDIVIDUAL_ALIAS?.ALIAS_NAME;
    if(type === 'entity')
        return getJsonData(data.data)?.ENTITY_ALIAS?.ALIAS_NAME;
    return null;
};

export const localizeIndividual = data => ({
    id: data.id,
    dataId: data.data_id,
    category:data?.category,
    categoryId: data.category_id,
    systemCheck: data.system_checked,
    firstName: getJsonData(data.data)?.FIRST_NAME,
    secondName: getJsonData(data.data)?.SECOND_NAME,
    alias: getAlias(data, 'individual'),
    dateOfBirth:formatDate(getJsonData(data.data)?.INDIVIDUAL_DATE_OF_BIRTH?.DATE),
    placeOfBirth: getJsonData(data.data)?.INDIVIDUAL_PLACE_OF_BIRTH,
    country: getJsonData(data.data)?.INDIVIDUAL_ADDRESS?.COUNTRY,
    city: getJsonData(data.data)?.INDIVIDUAL_ADDRESS?.CITY,
    nationality: getJsonData(data.data)?.NATIONALITY?.VALUE,
    address: getAddress(getJsonData(data.data)?.ADDRESS),
    otherInformation: getJsonData(data.data).COMMENTS1,
    functions:getJsonData(data.data)?.DESIGNATION?.VALUE,
    citizenshipRemarks: getJsonData(data.data)?.INDIVIDUAL_DOCUMENT,
    updatedOn: data.updated_on ? formatDate(data.updated_on) : null,
    scannedOn: data.scan_on ? formatDate(data.scan_on) : null,
    // eslint-disable-next-line no-nested-ternary
    result: data.scan_on ?
        (data.companies.length > 0 ?
            data.companies.map(company => `${company.name} ${company.type}`).join(", ") :
            'Not found'
        ) :
        null,
    listType: getJsonData(data.data)?.LIST_TYPE?.VALUE,
    unListType: getJsonData(data.data)?.UN_LIST_TYPE,
    referenceNumber: getJsonData(data.data)?.REFERENCE_NUMBER,
    uniqueId:`unique_${data.data_id}_${data.id}`,
    dataType: "individual",
});

export const localizeEntities = data => ({
    id: data.id,
    batchNo: data.batch_no,
    category:data?.category,
    categoryId: data.category_id,
    systemCheck: data.system_checked,
    name: getJsonData(data.data)?.FIRST_NAME,
    alias: getAlias(data, 'entity'),
    address: getAddress(getJsonData(data.data)?.ADDRESS),
    country: getCountry(getJsonData(data.data)?.ENTITY_ADDRESS),
    city: getJsonData(data.data)?.ENTITY_ADDRESS?.CITY,
    zipCode:  getJsonData(data.data)?.ENTITY_ADDRESS?.ZIP_CODE,
    street: getJsonData(data.data)?.ENTITY_ADDRESS?.STREET,
    otherInformation: getJsonData(data.data)?.COMMENTS1,
    updatedOn: data.updated_on ? formatDate(data.updated_on) : null,
    scannedOn: data.scan_on ? formatDate(data.scan_on) : null,
    // eslint-disable-next-line no-nested-ternary
    result: data.scan_on ?
        (data.companies.length > 0 ?
            data.companies.map(company => `${company.name} ${company.type}`).join(", ") :
            'Not found'
        ) :
        null,
    companies: data.companies,
    listType: getJsonData(data.data)?.LIST_TYPE?.VALUE,
    unListType: getJsonData(data.data)?.UN_LIST_TYPE,
    referenceNumber: getJsonData(data.data)?.REFERENCE_NUMBER,
    uniqueId:`unique_${data.data_id}_${data.id}`,
    dataType: "entity",
});
 
// const dd = JSON.parse(data.system_unchecked_entities[0].data.replaceAll(' " ', '"'));

export const localize = categoryDetail => ({
    id: categoryDetail.id,
    name : categoryDetail?.name,
    lastUpdated: formatDate(categoryDetail?.last_updated),
    status: categoryDetail?.status,
    entities: categoryDetail?.entities?.map(sce => localizeEntities(sce)),
    individuals: categoryDetail?.individuals?.map(sci => localizeIndividual(sci))
});